import { AccountOrderDetails } from '@/modules/account/api';
import { HomePageBannerProduct } from '@/modules/home/api';
import { ProductListItem } from '@/modules/product/api/productList';
import {
  IAncillaryProduct,
  Product,
  SeriesProduct,
} from '@/modules/product/api/singleProduct';

type ProductNameInput =
  | Product
  | IAncillaryProduct
  | HomePageBannerProduct
  | SeriesProduct
  | ProductListItem
  | AccountOrderDetails['products'][0];

export function productName(product?: null | ProductNameInput): string {
  if (!product) return '';

  const displayName = product.label ?? product.name;

  return displayName;
}
